import { render, staticRenderFns } from "./studentSelect.vue?vue&type=template&id=2707b52f&scoped=true&"
import script from "./studentSelect.vue?vue&type=script&lang=js&"
export * from "./studentSelect.vue?vue&type=script&lang=js&"
import style0 from "./studentSelect.vue?vue&type=style&index=0&id=2707b52f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2707b52f",
  null
  
)

export default component.exports